import React, { forwardRef } from "react";
import MonacoEditor from "@monaco-editor/react";

const PromptWriter = forwardRef(
  (
    {
      value,
      onChange,
      readOnly = false,
      language = "plaintext",
      paddingBottom = 28,
      wordwrap = "on",
    },
    ref,
  ) => {
    if (language === "jinja") {
      language = "twig"; // twig, liquid
    }

    // ensure the language is set to plaintext if its not on the list of known languages
    const monacoLanguages = [
      "plaintext",
      "abap",
      "apex",
      "azcli",
      "bat",
      "bicep",
      "cameligo",
      "clojure",
      "coffee",
      "cpp",
      "csharp",
      "csp",
      "css",
      "dart",
      "dockerfile",
      "ecl",
      "edge",
      "fsharp",
      "go",
      "graphql",
      "handlebars",
      "hcl",
      "html",
      "ini",
      "java",
      "javascript",
      "json",
      "julia",
      "kotlin",
      "less",
      "lexon",
      "liquid",
      "lua",
      "m3",
      "markdown",
      "mips",
      "msdax",
      "mysql",
      "objective-c",
      "pascal",
      "pascaligo",
      "perl",
      "pgsql",
      "php",
      "postiats",
      "powerquery",
      "powershell",
      "pug",
      "python",
      "r",
      "razor",
      "redis",
      "redshift",
      "restructuredtext",
      "ruby",
      "rust",
      "sb",
      "scala",
      "scheme",
      "scss",
      "shell",
      "sol",
      "sql",
      "st",
      "swift",
      "systemverilog",
      "tcl",
      "twig",
      "typescript",
      "vb",
      "verilog",
      "xml",
      "yaml",
    ];

    if (!monacoLanguages.includes(language)) {
      language = "plaintext";
    }

    return (
      <MonacoEditor
        className={`h-[calc(100%-${paddingBottom}px)]`}
        value={value}
        onChange={onChange}
        theme="vs-dark"
        language={language}
        options={{
          selectOnLineNumbers: true,
          fontSize: 14,
          minimap: { enabled: false },
          padding: { top: 20 },
          readOnly: readOnly,
          domReadOnly: readOnly,
          contextmenu: !readOnly,
          scrollBeyondLastLine: true,
          suggestOnTriggerCharacters: true,
          wordWrap: wordwrap,
          wordWrapColumn: 80,
          wrappingIndent: "indent",
        }}
        loading={<div className="h-full w-full bg-[#1E1E1E]"></div>}
        onMount={(editor) => {
          if (ref) {
            ref.current = { editor };
          }
        }}
      />
    );
  },
);

export default PromptWriter;
